import React, { useState } from 'react';
import { Paper, Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { JsonToCsvConverter, download } from '../../../Util/utilsFunctions';

// The view → like → checkout funnel per product. This is the page's workhorse:
// it surfaces high-interest / low-conversion products (a merchandising signal)
// and proven winners (high checkout rate). Sortable; click a row for the PDP.
const COLUMNS = [
  { key: 'trade_name', label: 'Product', numeric: false },
  { key: 'manufacturer_name', label: 'Manufacturer', numeric: false },
  { key: 'material_class', label: 'Class', numeric: false },
  { key: 'views', label: 'Views', numeric: true },
  { key: 'likes', label: 'Likes', numeric: true },
  { key: 'checkouts', label: 'Checkouts', numeric: true },
  { key: 'conversion', label: 'View→Sample', numeric: true },
];

const EngagementFunnel = ({ funnel }) => {
  const [sortKey, setSortKey] = useState('views');
  const [asc, setAsc] = useState(false);

  const rows = [...(funnel || [])].sort((a, b) => {
    const av = a[sortKey];
    const bv = b[sortKey];
    if (typeof av === 'string') {
      return asc
        ? (av || '').localeCompare(bv || '')
        : (bv || '').localeCompare(av || '');
    }
    return asc ? av - bv : bv - av;
  });

  const handleSort = (key) => {
    if (key === sortKey) setAsc(!asc);
    else {
      setSortKey(key);
      setAsc(false);
    }
  };

  const handleDownload = () => {
    if (!rows.length) return;
    const csv = JsonToCsvConverter(
      rows.map((r) => ({
        product: r.trade_name,
        manufacturer: r.manufacturer_name,
        class: r.material_class,
        style: r.style,
        views: r.views,
        likes: r.likes,
        checkouts: r.checkouts,
        view_to_sample_pct: (r.conversion * 100).toFixed(1),
      }))
    );
    download('Engagement-Funnel', csv);
  };

  return (
    <Paper className="insights__card insights__col-12" variant="outlined">
      <div className="insights__card-head">
        <div>
          <span className="insights__card-title">Engagement Funnel</span>{' '}
          <span className="insights__card-sub">
            views, likes &amp; sample checkouts by product
          </span>
        </div>
        <Button
          size="small"
          onClick={handleDownload}
          endIcon={<GetAppIcon />}
          disabled={!rows.length}
        >
          CSV
        </Button>
      </div>
      {rows.length === 0 ? (
        <div className="insights__empty">No product views in this period.</div>
      ) : (
        <div className="insights__scroll">
          <table className="insights__table">
            <thead>
              <tr>
                {COLUMNS.map((c) => (
                  <th
                    key={c.key}
                    className={c.numeric ? 'insights__num' : ''}
                    onClick={() => handleSort(c.key)}
                  >
                    {c.label}
                    {sortKey === c.key ? (asc ? ' ▲' : ' ▼') : ''}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.product_uuid}
                  onClick={() =>
                    window.open(`/product/${r.product_uuid}`, '_blank')
                  }
                >
                  <td>{r.trade_name}</td>
                  <td>{r.manufacturer_name}</td>
                  <td>{r.material_class}</td>
                  <td className="insights__num">{r.views}</td>
                  <td className="insights__num">{r.likes}</td>
                  <td className="insights__num">{r.checkouts}</td>
                  <td className="insights__num">
                    <span
                      className={`insights__pill ${
                        r.conversion >= 0.05 ? 'good' : 'warn'
                      }`}
                    >
                      {(r.conversion * 100).toFixed(1)}%
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Paper>
  );
};

export default EngagementFunnel;
